import { graphql } from "../__generated__";

export const QUERY_FETCH_HUMAN_CURRENT = graphql(`
  # import Human from '../fragments.ts/0_document.graphql'
  query human {
    human {
      ...Human
    }
  }
`);
